import {
  UserProfileDeletePudDocument,
  UserProfileDeletePudMutationResult,
  UserProfileDeletePudMutationVariables,
} from "@graphql/api";

export default async function userProfileDeletePud(
  id: number,
  locationId: number,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileDeletePudMutationVariables = {
    id,
    locationId,
  };
  const result: UserProfileDeletePudMutationResult = await client.mutate({
    mutation: UserProfileDeletePudDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileDeletePud.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileDeletePud.success;
}
